// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  var variant = evt.detail.variant;
  var variantId = evt.detail.variant.id;
  
  var optionHtml = document.querySelector("form.product-form .product-form__variants select option[value='" + variantId + "']");
  if ( optionHtml != undefined ){
    var productForm = optionHtml.closest("form.product-form");
    if ( productForm != undefined ){
      var productVariantsSelect = productForm.querySelector("select[name='id']");
      var preOrderDate = productForm.querySelector("select option[value='" + variantId + "']").getAttribute("preorderdate");
      var backOrderDate = productForm.querySelector("select option[value='" + variantId + "']").getAttribute("backorderdate");

      if ( productVariantsSelect.classList.contains("variants-preorder")){
        if ( variant.available ){
          if ( preOrderDate != "" ){
            productForm.querySelector(".pre-order-date").style.display = "block";
            productForm.querySelector(".pre-order-date").innerHTML = "Expected to ship no later than " + preOrderDate;
            productForm.querySelector("input[name='properties[Note]'").value = "Expected to ship no later than " + preOrderDate;
  
            productForm.querySelector("[data-add-to-cart-text]").innerHTML = "PreOrder Only";
          }else{
            productForm.querySelector(".pre-order-date").style.display = "none";
            productForm.querySelector(".pre-order-date").innerHTML = "";
            productForm.querySelector("input[name='properties[Note]'").value = "";

            productForm.querySelector("[data-add-to-cart-text]").innerHTML = "Add to Bag";
          }
        }else{
          productForm.querySelector(".pre-order-date").style.display = "none";
          productForm.querySelector(".pre-order-date").innerHTML = "";
          productForm.querySelector("input[name='properties[Note]'").value = "";
          
          productForm.querySelector("[data-add-to-cart-text]").innerHTML = "Sold Out";
        }
      }
      else if ( productVariantsSelect.classList.contains("variants-backorder") ){
        if ( variant.available ){
          if ( backOrderDate != "" ){
            productForm.querySelector(".backorder-date").style.display = "block";
            productForm.querySelector(".backorder-date").innerHTML = "Expected to ship no later than " + backOrderDate;
            productForm.querySelector("input[name='properties[Note]'").value = "Expected to ship no later than " + backOrderDate;
  
            productForm.querySelector("[data-add-to-cart-text]").innerHTML = "BackOrder Only";
          }else{
            productForm.querySelector(".backorder-date").style.display = "none";
            productForm.querySelector(".backorder-date").innerHTML = "";
            productForm.querySelector("input[name='properties[Note]'").value = "";
            
            productForm.querySelector("[data-add-to-cart-text]").innerHTML = "Add to Bag";
          }
        }else{
          productForm.querySelector(".backorder-date").style.display = "none";
          productForm.querySelector(".backorder-date").innerHTML = "";
          productForm.querySelector("input[name='properties[Note]'").value = "";
          
          productForm.querySelector("[data-add-to-cart-text]").innerHTML = "Sold Out";
        }
      }
      
    }
    
  }
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});


function onClickProductItemSwatch(e){
  var variantImageElement = e.querySelector(".product-item__image");
  var productItem = e.closest(".product-item__inner");
  
  if ( productItem !== undefined ){
    var imageOne = productItem.querySelector(".product-item__image--one");
    var imageTwo = productItem.querySelector(".product-item__image--two");

    if(window.matchMedia("(pointer: coarse)").matches) {
      imageOne.innerHTML = variantImageElement.innerHTML;
    }
    else{
      if ( imageTwo !== undefined ){
        imageTwo.innerHTML = variantImageElement.innerHTML;
      }
      else if ( imageOne !== undefined ){
        imageOne.innerHTML = variantImageElement.innerHTML;
      }
    }
  }
}
/*
const tabs = document.querySelectorAll('.header-tab');
const tab_navs = document.querySelectorAll('.tab-navigation');
if(tabs) {
  tabs.forEach(tab=>{
    tab.addEventListener('click', function(){
      if (this.classList.contains('active')) {
        return false;
      }
      tabs.forEach(sibling => sibling.classList.remove('active'));
      this.classList.add('active');
      const name = this.getAttribute('data-name');
      tab_navs.forEach(sibling => sibling.classList.remove('active'));
      document.querySelectorAll(`.tab-navigation[data-name="${name}"]`).forEach(nav=>{
        nav.classList.add('active');
      });
    });
  });
}
*/